import { AreaUnit as AntdAreaUnit } from "@empglabs/backoffice-ui-kit"

const AreaUnit = props => {
  return <AntdAreaUnit {...props} />
}

export default AreaUnit
